/**
 * 路径阶段
 * @author wql
 * @date 2020-08-18
 */

import React from 'react';
import { connect } from 'dva';
import { modelUtils } from '@/utils';

import { component_tool, framework_tool, utils_tool } from '@/tool';
import classnames from 'classnames';
import '@/styles/containers/train/path/trainPathStage/style.less'
import { Spin, Icon } from 'antd'
import { WizTableForm } from '@/containers/common';
import TrainPathInfo from './components/trainPathInfo';
import { element } from 'prop-types';
let { Storage } = utils_tool

let { Session } = utils_tool;

const exam = WizTableForm.Config.exam(this, { apiParams: { status: 1 } })
const program = WizTableForm.Config.program(this, { apiParams: { status: 1 } })
const trainPathComment = WizTableForm.Config.trainPathComment(this, { apiParams: { state: 2 } })
const offlineProgram = WizTableForm.Config.offlineProgram(this, { apiParams: { status: 1 } })
const series = WizTableForm.Config.series(this, { apiParams: { status: 1, type: 1 } })
const content = WizTableForm.Config.content(this, { apiParams: { releaseState: 1 } })
const homework = WizTableForm.Config.homework(this, { apiParams: { state: 1 } })

const {
  WizButton, WizRow, WizCol, WizNotice, WizIcon, WizTypography, WizForm, WizModal, WizRadio, WizTooltip,
  WizTable, WizCard, WizDropdown, WizMenu, WizTag, WizDivider, WizEmpty, Wizmessage, WizSearchBar, WizCustomSteps
} = component_tool;


const { WizContainer, WizAvatarUpload, ossFileUtils } = framework_tool;
const WizItem = WizMenu.Item


const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    if (history.location.pathname === '/trainPath/trainPathStage') {
      if (history.location && history.location.record) {
        record = history.location.record;
        Session.set('trainPathInfo', record)
      } else {
        record = Session.get('trainPathInfo') || 0
      }
    }
  } else {
    record = Session.get('trainPathInfo') || 0
  }
  return record
}

class TrainPathStage extends WizContainer {
  componentName = 'trainPathStage';

  constructor(props) {
    super(props);//props.history
    let use = Storage.getStorage('user') || {}
    //是否禁用编辑权限 (目前去除权限)
    this.flag = false
    // if(use && use.personId==='1cdf270fdc764dfb91634d3b2f48257f'){
    //   this.flag = false;
    // }

    this.state = {
      pathModalName: '',
      pathTaskModalName: '',
      columns: {},
      taskColumns: {},
      taskDate: [],
      record: {}, //当前选中路径的这条记录
      data: [], //所有的路径信息
      visible: false,
      taskVisible: false,
      apiParams: {},
      key: 0,
      selectedRowKeys:[],
      allowOpen : true,
      allowClose : true,
    };
    this.initialValue = getParamRecord(props.history);
    let fileId = this.initialValue.fileId ? getOssFilePath(this.initialValue.fileId) : constants.files.sys_path_default_image;
    this.initialValue.fileUri = fileId;
    this.stageData = {
      trainPathId: this.initialValue.id,
      trainPathStageInfo: {}
    };
  }

  _componentDidMount() {
    this._getStageList();
  }

  _getStageList() {
    this.doActions([
      {
        path: 'trainPathStage/stageList',
        payload: {
          key: 'chapterInfoKey',
          apiParams: { trainPathId: this.initialValue.id }
        }
      },
    ]);
  }
  _getSeriesInfo(nextProps, nextState) {
    let o = nextProps.getSeriesInfo;
    if (o['success']) {
      this.jumpPage('push', '/trainPath/seriesContentList', {...o['data']})
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  //START propsAndStateOnChange
  propsAndStateOnChange = {
    chapterInfo: this._chapterInfo.bind(this),
    saveTrainPathStage: this._handleCMD.bind(this),
    trainPathStageSort: this._trainPathStageSort.bind(this),
    trainPathTaskList: this._taskList.bind(this),
    trainPathTaskCMD: this._handleTaskCMD.bind(this),
    taskUpdateSort: this._taskUpdateSort.bind(this),
    getSeriesInfo: this._getSeriesInfo.bind(this),
  };

  _taskUpdateSort(nextProps, nextState) {
    let o = nextProps.taskUpdateSort;
    if (o['success']) {
      // wizNotice.success(o['msg'])
      this.getTaskList();
      this.setState({
        taskColumns: {},
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      this.setState({
        taskColumns: {},
      })
      return false;
    }
  }

  _trainPathStageSort(nextProps, nextState) {
    let o = nextProps.trainPathStageSort;
    if (o['success']) {
      // wizNotice.success(o['msg'])
      this._getStageList();
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _handleCMD(nextProps, nextState) {
    let o = nextProps.saveTrainPathStage;
    if (o['success']) {
      wizNotice.success(o['msg'])
      this._getStageList();
      return true;
    } else {
      wizNotice.error(o['msg'])
      this._getStageList();
      return true;
    }
  }



  _handleTaskCMD(nextProps, nextState) {
    let o = nextProps.trainPathTaskCMD;
    if (o['success']) {
      wizNotice.success(o['msg'])
      this._getStageList();
      this.getTaskList();
      this.setState({
        taskColumns: {},
        selectedRowKeys:[],
        allowOpen : true,
        allowClose : true,
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      this.setState({
        taskColumns: {},
        selectedRowKeys:[],
        allowOpen : true,
        allowClose : true,
      })
      return false;
    }
  }

  _taskList(nextProps, nextState) {
    let o = nextProps.trainPathTaskList;
    if (o['success']) {
      let data = o.data;
      data.forEach((e, index) => {
        if (e.type == 1) {
          e.typeName = '在线课程'
        } else if (e.type == 2) {
          e.typeName = '在线考试'
        } else if (e.type == 3) {
          e.typeName = '培训班级'
        } else if (e.type == 4) {
          e.typeName = '能力认证'
        } else if (e.type == 5) {
          e.typeName = '评语'
        } else if(e.type == 6) {
          e.typeName = '课程组'
        } else if (e.type == 7) {
          e.typeName = '资讯'
        } else if (e.type == 8) {
          e.typeName = '作业'
        }

        if (e.learningStyle == 1) {
          e.learningStyleName = '顺序学习'
        } else if (e.learningStyle == 0) {
          e.learningStyleName = '自主学习'
        }

        if (e.state == 1) {
          e.stateName = '草稿'
        } else if (e.state == 2) {
          e.stateName = '已发布'
        } else if (e.state == 3) {
          e.stateName = '已关闭'
        }
        // e.entityName = e.entityId;
        e.stageName = this.state.record.name;
      })
      this.state.taskDate = data;
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _chapterInfo(nextProps, nextState) {
    let chapterInfo = nextProps['chapterInfo'];
    this._updateStateForChapterInfo(chapterInfo, nextState)
    return true
  }

  _updateStateForChapterInfo(chapterInfo, nextState = {}) {
    if (chapterInfo && chapterInfo['success']) {
      let data = []
      if (chapterInfo['data'] && chapterInfo['data'] instanceof Array) {
        data = chapterInfo['data'];
      }
      nextState.data = data
      if (data.length > 0) {
        let id = this.state.record.id;
        if (id == null || id == undefined) {
          nextState.record = data[0];
          id = data[0].id;
        } else {
          data.forEach((e, index) => {
            if (e.id == id) {
              nextState.record = e;
            }
          })
        }
        this.doAction({
          path: 'trainPathTask/list',
          payload: {
            key: 'trainPathTaskList',
            apiParams: {
              trainPathStageId: id,
              trainPathId: this.initialValue.id,
            }
          }
        });
      }
    }
    return true;
  }


  //路径阶段按钮校验
  check = record => {
    if (record.id < 0) {
      WizNotice.warn('请选择路径')
      return false
    }
    return true;
  };

  //路径阶段更新按钮点击事件
  handleUpdate = (val) => {
    const { record } = this.state;
    if (!this.check(record)) return false;
    if (record.id == null || record.id == undefined) {
      WizNotice.warn('请先新增或选择路径阶段');
      return false;
    }
    this.stageData.trainPathStageInfo = record
    this.setState({
      pathModalName: '编辑培训',
      columns: record,
      visible: true
    });
  };

  //路径阶段部分点击事件
  handleClick = (val, index) => {
    this.setState({
      record: val,
      apiParams: {}
    });
    this.doAction({
      path: 'trainPathTask/list',
      payload: {
        key: 'trainPathTaskList',
        apiParams: {
          trainPathStageId: val.id,
        }
      }
    });
  };


  getTaskList() {
    let apiParams = this.state.apiParams
    apiParams.trainPathStageId = this.state.record.id
    this.doAction({
      path: 'trainPathTask/list',
      payload: {
        key: 'trainPathTaskList',
        apiParams: apiParams
      }
    });
  }




  //阶段删除按钮点击事件
  handleDelete = _ => {
    const { record } = this.state;
    if (!this.check(record)) return false;
    if (record.id == null || record.id == undefined) {
      WizNotice.warn('请先新增或选择路径阶段');
      return false;
    }
    if (record.state != 1) {
      WizNotice.warn('只有草稿状态的阶段才能删除');
      return false;
    }
    const content = `删除后数据不可恢复，您确定要删除选中的路径阶段吗？`;
    WizModal.confirm({
      title: '注意', content,
      onOk: () => {
        this.state.record = {}
        this.state.taskDate = []
        this.doAction({
          path: 'trainPathStage/delete',
          payload: {
            key: 'saveTrainPathStage',
            apiParams: { id: record.id }
          }
        });
      },
      onCancel() {
        return false;
      }
    });
  };

  //移动事件
  handleMove = flag => {
    const { record, data } = this.state;
    if (!this.check(record)) return false;
    if (record.id == null || record.id == undefined) {
      WizNotice.warn('请先新增或选择路径阶段');
      return false;
    }
    if (flag === 1) {
      //上移
      if (data[0].id == record.id) {
        WizNotice.warn('当前阶段已经是最上级阶段，不可再上移');
        return false;
      }
    } else if (flag === -1) {
      //下移
      if (data[data.length - 1].id == record.id) {
        WizNotice.warn('当前阶段已经是最下级阶段，不可再下移');
        return false;
      }
    } else {
      WizNotice.warn('参数不合法');
    }
    this.doAction({
      path: 'trainPathStage/sort',
      payload: {
        key: 'trainPathStageSort',
        apiParams: { id: record.id, sortType: flag }
      }
    });
  };

  //阶段列表
  _renderChapters(record, data = []) {
    if (data.length) {
      return data.map((val, index) => {
        let stateName = '';
        if (val.state == 1) {
          stateName = '[草稿]'
        } else if (val.state == 2) {
          stateName = '[已发布]'
        } else if (val.state == 3) {
          stateName = '[已关闭]'
        } else if (val.state == 4) {
          stateName = '[建设中]'
        }
        data[index].stateName = stateName;
        let className = classnames(
          'chapter-item',
          val.id === record.id ? 'active' : ''
        )
        return (
          <li key={val.sort} className={className} onClick={() => this.handleClick(val, index)}>
            <span className={stateName === '[已发布]' ? 'badge' : 'grey'}>{stateName}</span>
            {val.name}
          </li>
        )
      })
    }
    return null
  }

  //构建左侧按钮
  _buildButton(gridNum, className, type, onClickFun) {
    return (
      <WizCol span={gridNum && gridNum}>
        <WizButton type='link' onClick={onClickFun && onClickFun} disabled={this.flag}>
          <WizIcon className={className && className} type={type && type} />
        </WizButton>
      </WizCol>
    )
  }

  //路径左侧栏
  _renderChapterMenu() {
    const { record, data } = this.state;
    return (
      <div className='chapter'>
        <div className='chapter-title'>{'阶段目录'}</div>
        <div className='chapter-body'>
          <div className='operate'>
            <WizRow>
              {this._buildButton(5, 'icon-add', 'plus-circle', this.showModal)}
              {this._buildButton(5, 'icon-upd', 'edit', this.handleUpdate)}
              {this._buildButton(5, 'icon-circle', 'up-circle', () => this.handleMove(1))}
              {this._buildButton(5, 'icon-circle', 'down-circle', () => this.handleMove(-1))}
              {this._buildButton(4, 'icon-delete', 'delete', () => this.handleDelete())}
            </WizRow>
          </div>
          <ul className='chapter-items'>
            {this._renderChapters(record, data)}
          </ul>
        </div>
      </div>
    )
  }


  getTaskTable() {
    let data = this.state.taskDate;
    const columns = [
      { title: '顺序', dataIndex: 'sort', key: 'sort', width: 70},
      { title: '任务类型', dataIndex: 'typeName', key: 'typeName', width: 100 },
      { title: '任务状态', dataIndex: 'stateName', key: 'stateName', width: 100 },
      {
        title: '任务内容',
        dataIndex: 'entityName',
        key: 'entityName',
        width: 400,
        render: (text, record) => {
          if (record.type == 1) {
            return <a onClick={() => this.jumpPage('push', '/program/programList/programDetailShow', {id: record.entityId})}>{text}</a>
          } else if (record.type == 6) {
            return <a onClick={() =>  {
              this.doAction({
                path: 'series/getSeriesInfo',
                payload: {
                  key: "getSeriesInfo",
                  apiParams: { id: record.entityId }
                }
              })
            }}>{text}</a>
          } else {
            return <span>{text}</span>;
          }
        }
      },
      { title: '任务学习方式', dataIndex: 'learningStyleName', key: 'learningStyleName', width: 200 },
      { title: '添加时间', dataIndex: 'createTime', key: 'createTime', width: 200 },
      { title: '任务名称', dataIndex: 'name', key: 'name', width: 400 },
      { title: '备注', dataIndex: 'remark', key: 'remark', width: 400 },
      {
        title: '操作',
        fixed: 'right',
        key: 'action',
        width: 200,
        render: (text, record) => (
          <span>
            {!this.flag ? this._getAction(record) : undefined}
          </span>
        ),
      },
    ];

    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        let allowOpen = false;
        let allowClose = false;
        if(selectedRows && selectedRows.length >0){
          selectedRows.forEach(element=>{
            if(element.state==2){
              allowOpen = true;
            }
            if(element.state==3){
              allowClose = true;
            }
          })
        }else{
          allowOpen = true;
          allowClose = true;
        }

        this.setState({
          selectedRowKeys : selectedRowKeys,
          allowOpen : allowOpen,
          allowClose : allowClose,
        })
       // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
      },
      selectedRowKeys: this.state.selectedRowKeys || []
      // getCheckboxProps: (record) => ({
      //   disabled: record.name === 'Disabled User', // Column configuration not to be checked
      //   name: record.name,
      // }),
    };
    let dataTableProps = {
      loading: false,
      columns,
      dataSource: data,
      rowKey: "id",
     // selectType: "checkbox",
      rowSelection: rowSelection,
      showNum: false,
      isScroll: true,
      reasonable: true,
      pagination: false,
      scroll :{ x: 800, }
      // onChange: ({pageNum, pageSize}) => {
      //   //this.detailList(null, {current: pageNum, size: pageSize});
      // },

    };
    return (
      <WizTable  {...dataTableProps}   />
    )
  }

  _getAction(val) {
    let action = [];
    if (val.state == '1') {//草稿或者关闭状态
      action.push(<WizButton type="link" size={'small'} onClick={e => this.updateTaskClick(val)}>编辑</WizButton>)
      action.push(<WizDivider type="vertical" style={{ margin: 0 }} />)
      action.push(<WizButton type="link" size={'small'} onClick={e => this.updateTaskState(val)}>发布</WizButton>)
      action.push(<WizDivider type="vertical" style={{ margin: 0 }} />)
      action.push(<WizButton type="link" size={'small'} onClick={e => this.deleteTaskState(val)}>删除</WizButton>)
      action.push(<WizDivider type="vertical" style={{ margin: 0 }} />)
      const menu = (
        <WizMenu>
          <WizMenu.Item key="1"><WizButton type="link" size={'small'} onClick={e => this.updateTaskSort(val, -99)}>置顶</WizButton></WizMenu.Item>
          <WizMenu.Item key="1"><WizButton type="link" size={'small'} onClick={e => this.updateTaskSort(val, -1)}>上移</WizButton></WizMenu.Item>
          <WizMenu.Item key="2"><WizButton type="link" size={'small'} onClick={e => this.updateTaskSort(val, 1)}>下移</WizButton></WizMenu.Item>
          <WizMenu.Item key="1"><WizButton type="link" size={'small'} onClick={e => this.updateTaskSort(val, 99)}>置底</WizButton></WizMenu.Item>
        </WizMenu>
      );
      action.push(
        <WizDropdown overlay={menu}>
          <span>
            <Icon type="ellipsis" style={{ color: '#1890ff' }} />
          </span>
        </WizDropdown>
      )
    } else if (val.state == '2') {//已发布
      action.push(<WizButton type="link" size={'small'} onClick={e => this.updateTaskState(val)}>关闭</WizButton>)
      action.push(<WizDivider type="vertical" style={{ margin: 0 }} />)
      action.push(<WizButton type="link" size={'small'} onClick={e => this.updateTaskSort(val, -99)}>置顶</WizButton>)
      action.push(<WizButton type="link" size={'small'} onClick={e => this.updateTaskSort(val, -1)}>上移</WizButton>)
      action.push(<WizDivider type="vertical" style={{ margin: 0 }} />)
      action.push(<WizButton type="link" size={'small'} onClick={e => this.updateTaskSort(val, 1)}>下移</WizButton>)
      action.push(<WizButton type="link" size={'small'} onClick={e => this.updateTaskSort(val, 99)}>置底</WizButton>)
    } else if (val.state == '3') {//已关闭
      action.push(<WizButton type="link" size={'small'} onClick={e => this.updateTaskClick(val)}>编辑</WizButton>)
      action.push(<WizDivider type="vertical" style={{ margin: 0 }} />)
      action.push(<WizButton type="link" size={'small'} onClick={e => this.updateTaskState(val)}>发布</WizButton>)
      action.push(<WizDivider type="vertical" style={{ margin: 0 }} />)
      action.push(<WizButton type="link" size={'small'} onClick={e => this.updateTaskSort(val, -99)}>置顶</WizButton>)
      action.push(<WizButton type="link" size={'small'} onClick={e => this.updateTaskSort(val, -1)}>上移</WizButton>)
      const menu = (
        <WizMenu>
          <WizMenu.Item key="2"><WizButton type="link" size={'small'} onClick={e => this.updateTaskSort(val, 1)}>下移</WizButton></WizMenu.Item>
          <WizMenu.Item key="2"><WizButton type="link" size={'small'} onClick={e => this.updateTaskSort(val, 99)}>置底</WizButton></WizMenu.Item>
        </WizMenu>
      );
      action.push(
        <WizDropdown overlay={menu}>
          <a>
            <Icon type="ellipsis" style={{ color: '#1890ff' }} />
          </a>
        </WizDropdown>
      )
    }
    return action;
  }

  updateState(val) {
    let name = '';
    if (val == 1) {
      name = '草稿'
    } else if (val == 2) {
      name = '发布'
    } else if (val == 3) {
      name = '关闭'
    } else if (val == 4) {
      name = '建设中'
    }
    const content = '您确定要修改该阶段状态为' + name + '吗？';
    WizModal.confirm({
      title: '注意', content,
      onOk: () => {
        this.state.apiParams = {};
        this.state.key = this.state.key + 1;
        this.doAction({
          path: 'trainPathStage/closeOrRelease',
          payload: {
            key: 'saveTrainPathStage',
            apiParams: {
              id: this.state.record.id,
              state: val
            }
          }
        });
      },
      onCancel() {
      }
    });
  }

  getHref(val) {
    if (val == 1) {
      return (
        <WizCol span={4}><a onClick={e => this.updateState(2)}>发布</a></WizCol>
      )
    } else if (val == 2) {
      let data = [];
      data.push(<WizCol span={2}><a onClick={e => this.updateState(4)}>建设中</a></WizCol>)
      data.push(<WizCol span={2}><a onClick={e => this.updateState(3)}>关闭</a></WizCol>)
      return data;
    } else if (val == 3) {
      let data = [];
      data.push(<WizCol span={2}><a onClick={e => this.updateState(4)}>建设中</a></WizCol>)
      data.push(<WizCol span={2}><a onClick={e => this.updateState(2)}>发布</a></WizCol>)
      return data;
    } else if (val == 4) {
      let data = [];
      data.push(<WizCol span={2}><a onClick={e => this.updateState(2)}>发布</a></WizCol>)
      data.push(<WizCol span={2}><a onClick={e => this.updateState(3)}>关闭</a></WizCol>)
      return data;
    }
  }


  //任务新增点击事件
  handleMenuClick(e) {
    const { record } = this.state;
    if (!this.check(record)) return false;
    if (record.id == null || record.id == undefined) {
      WizNotice.warn('请先新增或选择路径阶段');
      return false;
    }
    let typeName = '';
    if (e.key == '1') {
      typeName = '在线课程';
    } else if (e.key == '2') {
      typeName = '在线考试';
    } else if (e.key == '3') {
      typeName = '培训班级';
    } else if (e.key == '4') {
      typeName = '能力认证';
    } else if (e.key == '5') {
      typeName = '评语';
    } else if (e.key == '6') {
      typeName = '课程组'
    } else if (e.key == '7') {
      typeName = '资讯'
    } else if (e.key == '8') {
      typeName = '作业'
    }
    if (e.key == '4') {
      WizModal.info({
        title: '新增任务',
        content: (
          <div>
            <WizEmpty image={WizEmpty.PRESENTED_IMAGE_SIMPLE} description={<span>暂未开放，敬请期待</span>} />
          </div>
        ),
        onOk() {
        },
      });
    } else {
      this.setState({
        pathTaskModalName: '新增任务',
        taskColumns: { type: e.key, typeName: typeName },
        taskVisible: true,
      });
    }
  }

  //任务编辑点击事件
  updateTaskClick(e) {
    this.setState({
      pathTaskModalName: '编辑任务',
      taskColumns: e,
      taskVisible: true,
    });
  }

  //任务状态修改事件
  updateTaskState(e) {
    let ids = [];
    ids.push(e.id);
    let state = '';
    if (e.state == 1 || e.state == 3) {//当前状态草稿或者关闭
      state = 2;
    } else if (e.state == 2) {//当前状态发布
      state = 3
    }

    let name = '';
    if (state == 2) {
      name = '发布'
    } else {
      name = '关闭'
    }

    let taskTypeList = []
    taskTypeList.push(e.type)
    const content = '您确定要' + name + '该任务？';
    WizModal.confirm({
      title: '注意', content,
      onOk: () => {
        this.doAction({
          path: 'trainPathTask/updateState',
          payload: {
            key: 'trainPathTaskCMD',
            apiParams: {
              ids: ids,
              state: state,
              taskTypeList
            }
          }
        });
      },
      onCancel() {
      }
    });

  }

  //任务移动事件
  updateTaskSort(e, type) {
    let apiParams = {}
    let data = this.state.taskDate;
    let indexNum = 0;
    data.forEach((value, index) => {
      if (e.id == value.id) {
        indexNum = index
      }
    })
    let path = 'trainPathTask/updateSort';
    if (type == 1) {//下移
      if (indexNum >= data.length - 1) {
        WizNotice.warn('该任务已经是最下级任务，不能再下移')
        return false
      } else {
        //上下级排序互换
        let nextDate = data[indexNum + 1]
        apiParams.prevId = e.id;
        apiParams.prevSort = nextDate.sort;
        apiParams.nextId = nextDate.id;
        apiParams.nextSort = e.sort;
      }
    } else if (type == -1){ //上移
      if (indexNum <= 0) {
        WizNotice.warn('该任务已经是最上级任务，不能再上移')
        return false
      } else {
        //上下级排序互换
        let prevDate = data[indexNum - 1]
        apiParams.prevId = prevDate.id;
        apiParams.prevSort = e.sort;
        apiParams.nextId = e.id;
        apiParams.nextSort = prevDate.sort;
      }
    }else if (type == 99){
      if (indexNum >= data.length - 1) {
        WizNotice.warn('该任务已经是最下级任务，不能再置底')
        return false
      }
      path = 'trainPathTask/updateSortAll';
      apiParams.id = e.id;
      apiParams.trainPathStageId = e.trainPathStageId;
      apiParams.sort = e.sort;
      apiParams.type = 0;
    }else if (type == -99){
      if (indexNum <= 0) {
        WizNotice.warn('该任务已经是最上级任务，不能再置顶')
        return false
      }
      path = 'trainPathTask/updateSortAll';
      apiParams.id = e.id;
      apiParams.trainPathStageId = e.trainPathStageId;
      apiParams.sort = e.sort;
      apiParams.type = 1;
    }
    this.doAction({
      path: path,
      payload: {
        key: 'taskUpdateSort',
        apiParams: apiParams
      }
    });
  }

  //任务删除事件
  deleteTaskState(e) {
    let ids = [];
    ids.push(e.id);
    if (e.state == 1) {//当前状态草稿
      // const content = `您确定要删除该任务吗？`;
      const content = `删除后数据不可恢复，您确定要删除选中的路径任务吗？`;
      WizModal.confirm({
        title: '注意', content,
        onOk: () => {
          this.doAction({
            path: 'trainPathTask/del',
            payload: {
              key: 'trainPathTaskCMD',
              apiParams: {
                ids: ids
              }
            }
          });
        },
        onCancel() {
          return false;
        }
      });
    } else {
      Wizmessage.error('只有草稿状态才能删除！');
    }
  }

  _taskMenu() {
    //需求隐藏能力认证和课程组
    // <WizItem key='4'>
    //能力认证
    //</WizItem>
    return (
      <WizMenu onClick={this.handleMenuClick.bind(this)}>
        <WizItem key='1'>
          在线课程
        </WizItem>
        <WizItem key='2'>
          在线考试
        </WizItem>
        <WizItem key='3'>
          培训班级
        </WizItem>
        <WizItem key='5'>
          评语
        </WizItem>
        <WizItem key='6'>
          课程组
        </WizItem>
        <WizItem key='7'>
          资讯
        </WizItem>
        <WizItem key='8'>
          作业
        </WizItem>
      </WizMenu>
    );
  }

  /**
   * 批量更新路径任务
   * @param values
   * @private
   */
   _batchUpdateState(state) {
    console.log("selectedRowKeys==",this.state.selectedRowKeys)
    let ids = this.state.selectedRowKeys;
    let name = '';
    if (state == 2) {
      name = '发布'
    } else {
      name = '关闭'
    }
    const content = '您确定要' + name + '该任务？';
    WizModal.confirm({
      title: '注意', content,
      onOk: () => {
        this.doAction({
          path: 'trainPathTask/updateState',
          payload: {
            key: 'trainPathTaskCMD',
            apiParams: {
              ids: ids,
              state: state
            }
          }
        });
      },
      onCancel() {
      }
    });
  }

  //右侧路径信息
  _renderChapterInfo() {
    let stageInfo = this.state.record;
    const { fileId,pathMapFileId, type, learningStyle } = stageInfo;
    let learningStyleName = '';
    let typeName = '';
    if (learningStyle == 0) {
      learningStyleName = '自主学习'
    } else if (learningStyle == 1) {
      learningStyleName = '顺序学习'
    }
    if (type == 0) {
      typeName = '选修'
    } else if (type == 1) {
      typeName = '必修'
    }
    const menu = this._taskMenu(this);
    let file = {};
    console.log("fileId----",fileId);
    file.url = fileId ? getOssFilePath(fileId) : constants.files.sys_pathStage_default_image;
    console.log(" file.url===", file.url);
    let pathMapFile = {};
    pathMapFile.url = pathMapFileId ? getOssFilePath(pathMapFileId) : '';
    let columns = [
      {
        title: '任务名称',
        name: 'searchName', searchItem: {},
        formItem: {}
      },
      {
        title: '任务类型',
        name: 'type', searchItem: {
          type: 'select', dict: [
            { code: 1, codeName: '在线课程' },
            { code: 2, codeName: '在线考试' },
            { code: 3, codeName: '培训班级' },
            { code: 5, codeName: '评语' },
            { code: 6, codeName: '课程组' },
            { code: 7, codeName: '资讯' },
            { code: 8, codeName: '作业' },
          ],
        },
        formItem: {}
      },
      {
        title: '任务学习方式',
        name: 'learningStyle', searchItem: {
          type: 'select', dict: [
            { code: 0, codeName: '自主学习' },
            { code: 1, codeName: '顺序学习' },
          ],
        },
        formItem: {}
      },
      {
        title: '任务状态',
        name: 'state', searchItem: {
          type: 'select', dict: [
            { code: 1, codeName: '草稿' },
            { code: 2, codeName: '已发布' },
            { code: 3, codeName: '已关闭' },
          ],
        },
        formItem: {}
      },
    ];
    let searchBarProps = {
      columns,
      onSearch: values => {
        let apiParams = values;
        apiParams.trainPathStageId = this.state.record.id
        this.state.apiParams = apiParams
        this.doAction({
          path: 'trainPathTask/list',
          payload: {
            key: 'trainPathTaskList',
            apiParams: apiParams
          }
        })
      }
    };


    return (
      <div className='chapter-info'>
        <div className='chapter-info-title'>
          <WizTypography.Text className='title'>
            <WizRow>
              <WizCol span={20}>阶段信息</WizCol>
              {this.getHref(stageInfo.state)}
            </WizRow>
          </WizTypography.Text>
        </div>
        <div className='chapter-info-body'>
          <div className="form-control">
            <WizRow className='row-item'>
              <WizCol className='col-item' span={4} offset={1}>{'阶段名称' + '： '}</WizCol>
              <WizCol span={7}>{stageInfo.name}</WizCol>
              <WizCol className='col-item' span={3} offset={1}>{'阶段类型' + '： '}</WizCol>
              <WizCol span={8}>{typeName}</WizCol>
            </WizRow>
            <WizRow className='row-item'>
              <WizCol className='col-item' span={4} offset={1}>{'阶段学习方式' + '： '}</WizCol>
              <WizCol span={7}>{learningStyleName}</WizCol>
              <WizCol className='col-item' span={3} offset={1}>{'阶段状态' + '： '}</WizCol>
              <WizCol span={8}>{stageInfo.stateName}</WizCol>
            </WizRow>
            <WizRow className='row-item'>
              <WizCol className='col-item' span={4} offset={1}>{'阶段备注' + '： '}</WizCol>
              <WizCol span={7}>{stageInfo.remark}</WizCol>
              {/* <WizCol className='col-item' span={3} offset={1}>{'阶段线路图' + '： '}</WizCol> */}
              {/* <WizCol span={8}><img src={pathMapFile.url || constants.files.sys_pathMap_default_image} style={{ height: 100, width: 100 }} /></WizCol> */}
            </WizRow>
            <WizRow className='row-item'>
              <WizCol className='col-item' span={4} offset={1}>{'阶段图标' + '： '}</WizCol>
              <WizCol span={7}>{(<img src={file.url} style={{ height: 100, width: 100 }} />)}</WizCol>
              {/* <WizCol className='col-item' span={3} offset={1}>{'阶段线路图' + '： '}</WizCol> */}
              {/* <WizCol span={8}><img src={pathMapFile.url || constants.files.sys_pathMap_default_image} style={{ height: 100, width: 100 }} /></WizCol> */}
            </WizRow>
          </div>
          <hr width='100%' style={{ height: 1 }}></hr>
          <div className='chapter-info-body'>
            <div className="form-control">
              <WizSearchBar key={this.state.record.id + this.state.key}
                className='searchbar-interval'
                type="grid"
                {...searchBarProps}
                cols={{ xs: 14, md: 12, xl: 10 }}
              />
              <div>
                <WizDropdown overlay={menu} disabled={this.flag}>
                  <WizButton type='primary' style={{ marginLeft: 15, marginTop: 15, marginBottom: 15 }} >
                    新增任务
                  </WizButton>
                </WizDropdown>
                <WizButton  onClick={() => {
                   this._batchUpdateState(2)
                 }} disabled={this.state.allowOpen} style={{ marginLeft: 15, marginTop: 15, marginBottom: 15 }} >
                    批量发布
                </WizButton>
                <WizButton  onClick={() => {
                   this._batchUpdateState(3)
                 }} disabled={this.state.allowClose} style={{ marginLeft: 15, marginTop: 15, marginBottom: 15 }} >
                    批量关闭
                </WizButton>
              </div>
              {/*<WizDataTable {...dataTableProps} />*/}
              {this.getTaskTable()}
            </div>
          </div>


        </div>
      </div>


    )
  }

  stepView = () => {
    return (
      <div className='train-path-stageWrp'>
        <div className='train-path-stage'>
          <WizRow>
            <WizCol span={7} className='chapter-col'>
              {this._renderChapterMenu()}
            </WizCol>
            <WizCol span={17}>
              {this._renderChapterInfo()}
            </WizCol>
          </WizRow>
        </div>
      </div>
    )
  }

  showModal = () => {
    this.setState({
      pathModalName: '新增阶段',
      columns: {},
      visible: true,
    });
  };

  handleOk() {
    this.ref.validateFields((err, values) => {
      if (!err) {
        this._save(values);
        this.setState({
          visible: false,
        });
      }
      return
    });
  };

  taskHandleOk() {
    this.ref.validateFields((err, values) => {
      if (!err) {
        this._saveTask(values);
        this.setState({
          taskVisible: false,
        });
      }
      return
    });
  };

  handleCancel() {
    this.setState({
      visible: false,
    });
  };

  taskHandleCancel() {
    this.setState({
      taskVisible: false,
      taskColumns: {},
    });
  };

  imgStyle() {
    return {
      width: 260,
      height: 130,
      backgroundImage: 'url(' + this.initialValue.fileUri + ')',
      backgroundPosition: 'center 0',
      backgroundSize: '100% 100%',
      backgroundRepeat: 'no-repeat',
    }
  }

  _render() {
    console.log(this.state.record,'this.state.record')
    let { trainPathStageLoading, trainPathTaskLoading } = this.props
    let columns = [
      {
        formItem: {
          type: "hidden",
          initialValue: this.stageData.trainPathId,
        },
        name: "trainPathId"
      },
      {
        formItem: {
          type: "hidden",
          initialValue: this.state.columns.id,
        },
        name: "id"
      },
      {
        title: "阶段名称",
        name: "name",
        formItem: {
          maxlength: 20,
          // placeholder: '路径名称最多输入30个字',
          rules: [{
            required: true,
            message: '请输入阶段名称',
          }],
          initialValue: this.state.columns.name,
        },
      },
      {
        title: "阶段类型",
        name: "type",
        formItem: {
          type: 'diy',
          // rules: [{
          //   required: true,
          //   message: '请选择阶段类型',
          // }],
          initialValue: this.state.columns.type === 0 ? 0 : 1,
          diy: ({ value, onChange, initialValue = 1 }) => {
            return <WizRadio.Group onChange={(e) => { onChange(e.target.value) }} value={value !== undefined ? value : initialValue}>
              <div>
                <WizRadio value={1}>必修</WizRadio>
                <span>
                  <WizTooltip title="路径中必须要完成的阶段">
                    <WizIcon type="question-circle-o" />
                  </WizTooltip>
                </span>
              </div>
              <div>
                <WizRadio value={0}>选修</WizRadio>
                <span>
                  <WizTooltip title="路径中选择完成的阶段">
                    <WizIcon type="question-circle-o" />
                  </WizTooltip>
                </span>
              </div>
            </WizRadio.Group>
          }
        },
      },
      {
        title: "学习方式",
        name: "learningStyle",
        formItem: {
          type: 'diy',
          // rules: [{
          //   required: true,
          //   message: '请选择学习方式',
          // }],
          initialValue: this.state.columns.learningStyle ? this.state.columns.learningStyle : 0,
          diy: ({ value, onChange, initialValue = 0 }) => {
            return <WizRadio.Group onChange={(e) => { onChange(e.target.value) }} value={value !== undefined ? value : initialValue}>
              <div>
                <WizRadio value={0}>自主学习</WizRadio>
                <span>
                  <WizTooltip title="不需要按照顺序可随意学习">
                    <WizIcon type="question-circle-o" />
                  </WizTooltip>
                </span>
              </div>
              <div>
                <WizRadio value={1}>顺序学习</WizRadio>
                <span>
                  <WizTooltip title="需要按顺序学习,前面的顺序阶段完成后才可以开始学习本阶段">
                    <WizIcon type="question-circle-o" />
                  </WizTooltip>
                </span>
              </div>
            </WizRadio.Group>
          }
        },
      },
      {
        title: <span>
        上传图标&nbsp;
        <WizTooltip title="请上传大小不超过2MB,图片尺寸建议200*200">
            <WizIcon type="question-circle-o" />
        </WizTooltip>
      </span>,
        name: "fileId",
        dataIndex: "fileId",
        formItem: {
          type: 'custom',
          render: (record, form) => {
            record = this.state.columns;//initialValue;
            const { getFieldDecorator } = form;
            let imgOne = null;
            let fileName = null;
            let fileMimeType = null;
            let fileSize = null;
            let fileUri = null;
            if (record != null && record.fileId != null) {
              imgOne = record.fileId;
              fileName = record.fileName;
              fileMimeType = record.fileMimeType;
              fileSize = record.fileSize;
              fileUri = record.fileUri;
            }
            return (
              <div>
                {
                  getFieldDecorator('fileId', {
                    initialValue:
                      (record && record.fileId) ? [
                        { fileId: imgOne }
                      ] : []
                    // , rules: [{
                    //   required: true,
                    //   message: '请选择图标',
                    // }]
                  })(
                    <WizAvatarUpload
                      accept={'.jpg, .jpeg, .png'}
                      listType={'picture-card'}
                      aspectRatio={200 / 200}
                      beforeUpload={(file) => {
                        let result = true;
                        const isLt1M = file.size / 1024 / 1024 < 2;
                        if (file.type.indexOf('image/') == -1) {
                          Wizmessage.error('只能上传图片类型,请重新选择!');
                          result = false;
                        } else if (!isLt1M) {
                          Wizmessage.error('图片不得超过2M!');
                          result = false;
                        }
                        return result;
                      }}
                    />
                  )
                }
              </div>)
          }
        }
      },
      {
        title: '备注',
        name: 'remark',
        dataIndex: 'remark',
        formItem: {
          type: 'textarea',
          placeholder: '请输入阶段备注',
          maxLength: 50,
          initialValue: this.state.columns.remark,
        },
      },
      /* ,
       {
        title: "阶段线路图",
        name: "pathMapFileId",
        dataIndex: "pathMapFileId",
        formItem: {
          type: 'custom',
          render: (record, form) => {
            record = this.state.columns;//initialValue;
            const { getFieldDecorator } = form;
            let imgOne = null;
            if (record != null && record.pathMapFileId != null) {
              imgOne = record.pathMapFileId;
            }
            return (
              <div>
                {
                  getFieldDecorator('pathMapFileId', {
                    initialValue:
                      (record && record.pathMapFileId) ? [
                        { fileId: imgOne }
                      ] : []
                    ,
                  })(
                    <WizAvatarUpload
                      accept={'.jpg, .jpeg, .png'}
                      listType={'picture-card'}
                      aspectRatio={400 / 400}
                      beforeUpload={(file) => {
                        let result = true;
                        const isLt1M = file.size / 1024 / 1024 < 2;
                        if (file.type.indexOf('image/') == -1) {
                          Wizmessage.error('只能上传图片类型,请重新选择!');
                          result = false;
                        } else if (!isLt1M) {
                          Wizmessage.error('图片不得超过2M!');
                          result = false;
                        }
                        return result;
                      }}
                    />
                  )
                }
              </div>)
          }
        }
      }  */
    ]
    let onSubmit = this._save.bind(this);
    let formProps = {
      ref: 'form',
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: false,
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 16 }
      }
    }

    return <Spin tip={'加载中'} spinning={trainPathStageLoading || trainPathTaskLoading}>
      <TrainPathInfo {...this.initialValue} />
      <WizCard title={'路径阶段管理'} className="path-stage-wrp">
        {this.stepView()}
      </WizCard>

      {/*新增、修改培训弹框*/}
      <WizModal key={new Date().getTime()} title={this.state.pathModalName} visible={this.state.visible}
        onOk={this.handleOk.bind(this)} onCancel={this.handleCancel.bind(this)}>
        <WizForm key={new Date().getTime()} className={'form-inline'} {...formProps} ref={r => {
          this.ref = r;
        }} />
      </WizModal>

      {/*新增、修改任务弹框*/}
      <WizModal key={this.state.taskColumns.id + '_' + this.state.taskColumns.type} title={this.state.pathTaskModalName}
        visible={this.state.taskVisible} onOk={this.taskHandleOk.bind(this)}
        onCancel={this.taskHandleCancel.bind(this)}>
        <WizForm className={'form-inline'} {...this.getTaskModal()} ref={r => {
          this.ref = r;
        }}></WizForm>
      </WizModal>
    </Spin>
  }

  /**任务内容验证 */
  contentValidator = (rule, value, callback) => {
    if (!value) {
      callback('请选择任务内容')
    }
    callback();
  }

  /**任务内容编辑框字段 */
  _columns = () => {
    let entityName = this.state.taskColumns.entityName;
    let initRows = [{ id: this.state.taskColumns.entityId, name: entityName, title: entityName }]
    let type = this.state.taskColumns.type;
    //其它插件默认暂时用在线课程插件代替
    let config = program;
    if (type == 1) {
      config = program
    } else if (type == 2) {
      config = exam
    } else if (type == 3) {
      config = offlineProgram
    } else if (type == 5) {
      config = trainPathComment
    } else if (type == 6) {
      config = series
    } else if (type == 7) {
      config = content;
    } else if (type == 8) {
      config = homework;
    }
    return [
      {
        formItem: {
          type: "hidden",
          initialValue: this.state.taskColumns.id,
        },
        name: "id"
      },
      {
        formItem: {
          type: "hidden",
          initialValue: this.initialValue.id,
        },
        name: "trainPathId"
      },
      {
        formItem: {
          type: "hidden",
          initialValue: this.state.record.id,
        },
        name: "trainPathStageId"
      },
      {
        name: "type",
        formItem: {
          type: "hidden",
          initialValue: this.state.taskColumns.type,
        },
      },
      {
        title: "任务类型",
        name: "typeName",
        formItem: {
          rules: [{
            required: true,
            message: '请选择任务类型',
          }],
          type: 'custom',
          render: () => {
            return <div>{this.state.taskColumns.typeName && this.state.taskColumns.typeName}</div>
          }
        },
      },
      {
        title: "任务内容",
        name: "entityId",
        formItem: {
          ...config,
          rules: [{ required: true, validator: this.contentValidator, }],
          diy: WizTableForm,
          placeholder: '请选择任务内容',
          selectType: 'radio',
          disabled: this.state.taskColumns.entityId && this.state.taskColumns.entityId != null ? true : false,
          initialValue: this.state.taskColumns.entityId && this.state.taskColumns.entityId,
          initRows: initRows,
          onChange: (form, value, rows) => {
            if (type == 2 || type == 7) {
              let name = rows[0].title;
              form.setFieldsValue({ name: name })
            } else {
              if (rows && rows instanceof Array && rows.length > 0) {
                const { id, name } = rows[0];
                form.setFieldsValue({ name: name })
              }
            }
          },
        }
      },
      {
        title: "任务名称",
        name: "name",
        formItem: {
          maxlength: 20,
          links: { 'entityId': '任务内容' },
          rules: [{
            required: true,
            message: '请输入任务名称',
          }],
          initialValue: this.state.taskColumns.name,
        },
      },

      {
        title: "学习方式",
        name: "learningStyle",
        formItem: {
          rules: [{
            required: true,
            message: '请输入学习方式',
          }],
          type: 'radio',
          initialValue: this.state.taskColumns.learningStyle ? this.state.taskColumns.learningStyle : 0,
          dict: [
            { code: 0, codeName: "自主学习" },
            { code: 1, codeName: "顺序学习" }
          ],
        },
      },
      {
        title: '备注',
        name: 'remark',
        dataIndex: 'remark',
        formItem: {
          type: 'textarea',
          placeholder: '请输入任务备注',
          maxLength: 20,
          initialValue: this.state.taskColumns.remark,
        },
      },
    ]
  }

  getTaskModal() {
    let columns = this._columns()
    let onSubmit = this._saveTask.bind(this);
    let formProps = {
      ref: 'form',
      columns,
      onSubmit,
      record: null,//this.state.taskColumns,
      preview: null,
      footer: false,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 }
      }
    }
    return formProps;
  }

  /**
   * 保存和更新路径任务
   * @param values
   * @private
   */
  _saveTask(values) {
    let apiPath = '';
    if (values.id) {
      apiPath = "trainPathTask/upd"
    } else {
      apiPath = "trainPathTask/add";
      this.state.apiParams = {};
      this.state.key = this.state.key + 1;
    }
    this.doAction({
      path: apiPath,
      payload: {
        key: 'trainPathTaskCMD',
        apiParams: {
          ...values
        }
      }
    });
  }


  /**
   * 保存和更新路径阶段
   * @param values
   * @private
   */
  _save(values) {
    if (values['fileId'].length > 0){
      values.fileId = values['fileId'][0].fileId;
    }else{
      values.fileId = '';
    }
    /* if (values['pathMapFileId'].length > 0){
      values.pathMapFileId = values['pathMapFileId'][0].fileId;
    }else{
      values.pathMapFileId = '';
    } */
    let apiPath = "trainPathStage/add";
    if (values.id) {
      apiPath = "trainPathStage/upd"
    }
    this.doAction({
      path: apiPath,
      payload: {
        key: 'saveTrainPathStage',
        apiParams: {
          ...values
        }
      }
    });
  }

  reset() {
    let _nextState = this._updateStateForChapterInfo(this.props.chapterInfo)
    this.setState({ ..._nextState })
  }


}

const mapStateToProps = (state, ownProps) => {
  const { trainPathStage, trainPathTask, series } = state;
  const chapterInfo = modelUtils.getModelEntity(trainPathStage, "chapterInfoKey");
  const saveTrainPathStage = modelUtils.getModelEntity(trainPathStage, "saveTrainPathStage");
  const trainPathStageSort = modelUtils.getModelEntity(trainPathStage, "trainPathStageSort");
  const trainPathTaskList = modelUtils.getModelEntity(trainPathTask, "trainPathTaskList");
  const trainPathTaskCMD = modelUtils.getModelEntity(trainPathTask, "trainPathTaskCMD");
  const taskUpdateSort = modelUtils.getModelEntity(trainPathTask, "taskUpdateSort");
  const getSeriesInfo = modelUtils.getModelEntity(series, "getSeriesInfo");

  const load = modelUtils.getLoadingState(state, ['trainPathStage', 'trainPathTask']);
  return {
    chapterInfo,
    saveTrainPathStage,
    trainPathStageSort,
    trainPathTaskList,
    trainPathTaskCMD,
    taskUpdateSort,
    getSeriesInfo,
    ...load
  }
};

export default connect(mapStateToProps)(TrainPathStage);
